<template><v-app>
    <v-main>
            <headerBottomVue />

    <v-container fluid>
    <v-card class="mx-auto" max-width="1380" v-if="$store.state.searchData.isSearchResult == true">
        <searchvue />
    </v-card>
    <v-card class="pa-6 mx-auto" max-width="1380" v-if="$store.state.searchData.isSearchResult == false">
            <v-card-title><h1 id="head">Mapa strony</h1></v-card-title>
            <v-divider></v-divider>
            <ul v-for="item in items" >
                <li>
                    <h1><router-link :to="getUrl(item.url)">{{ item.categoryName}}</router-link></h1>
                        <ul v-if="item.children" v-for="(child) in item.children">
                            <li><h2><router-link :to="getUrl(child.url) +'/'+child.categorySlug">{{ child.categoryName}}</router-link></h2>
                                    <ul v-if="child.children" v-for="(child1) in child.children">
                                        <li><h3><router-link :to="getUrl(child1.url) +'/'+child1.categorySlug">{{ child1.categoryName}}</router-link></h3>
                                            <ul v-if="child1.children" v-for="(child2) in child1.children">
                                                <li><h4><router-link :to="getUrl(child2.url) +'/'+child2.categorySlug">{{ child2.categoryName}}</router-link></h4>
                                                        <ul v-if="child2.children" v-for="(child3) in child2.children">
                                                            <li>
                                                                <h5><router-link :to="getUrl(child3.url) +'/'+child3.categorySlug">{{ child3.categoryName}}</router-link></h5>
                                                            </li>
                                                        </ul>
                                               </li>
                                            </ul>

                                        </li>
                                    </ul>
                            </li>
                        </ul>
                </li>
            </ul>

        </v-card>
    </v-container>
    </v-main>
    </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import headerBottomVue from "./HeaderBottom.vue";
import searchvue from "./Search.vue";
import footerBlueVue from "./FooterBlue.vue";
import footerRedVue from "./FooterRed.vue";


export default {
    components: {
        headerBottomVue,
        searchvue,
        footerRedVue,
        footerBlueVue,
    },
    data: () => ({
        items: []
    }),

    methods: {
        getUrl(jsonUrl){
            let htmlUrl = "";
            if (jsonUrl){
                let arrayUrl;
                arrayUrl = JSON.parse(jsonUrl);
                let maxArrayElement = arrayUrl.length;
                let step = 0;
                for (step = 0; step < maxArrayElement; step++) {
                    htmlUrl = htmlUrl + "/" + arrayUrl[step].href;
                };
            }
            return htmlUrl;

        }
    },
    async created() {
        const res = await this.callApi("get", "get_category_list");
        if (res.status === 200) {
           this.items = res.data;
        }
    },
};
</script>
<style scoped>
#head{
            background: #f5f5f5;
            text-transform: uppercase;
            border-left: 6px solid #db0f38;
            border-top: 1px solid #e9e9e9;
            border-right: 1px solid #e9e9e9;
            border-bottom: 1px solid #e9e9e9;
            font-weight: normal;
            padding: 8px;
            color: black;
            margin: 0px 0px 0px 0px;
        }



h1 {
    background: #f5f5f5;
    text-transform: uppercase;
    border-left: 6px solid #C20444;
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    padding: 6px 0px 6px 6px;
    color: black;
    font-size: 1.2em;
}

h2 {
    background: #f5f5f5;
    border-left: 6px solid #4476b8;
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    font-weight: 900;
    font-size: 1.0em;
    padding: 6px 0px 6px 6px;
}

h3 {
    border-left: 6px solid #05355a;
    background: #f5f5f5;
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    font-weight: 700;
    font-size: 1.0em;
    padding: 6px 0px 6px 6px;
}

h4 {
    border-left: 6px solid grey;
    background: #f5f5f5;
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    font-weight: 400;
    padding: 6px 0px 6px 6px;
        font-size: 1.0em;
}

h5 {
    border-left: 6px solid green;
    background: #f5f5f5;
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
    font-weight: 300;
    padding: 6px 0px 6px 6px;
        font-size: 1.0em;
    }

ul, ol {
    padding: 6px 0px 0px 0px;
    list-style: none;
    text-decoration: none;
}
a:visited {
    text-decoration: none;
    color: black;

}
a:link {
     text-decoration: none;
     color: black;

}

a:hover {
    text-decoration: none;
    color: #C20444;
}
li {
    margin-left: 1em;
    padding: 2px;
        list-style: none;
        text-decoration: none;

}
</style>
